/**
 * Read-only identity pill ("jane.doe@example.com [pencil]") used by
 * every post-identifier state (OTP, reset, method picker, continue
 * username). Pencil click sends the user back to the relevant entry
 * step via the onEdit callback owned by the parent.
 */

"use client";

import { IconPencil } from "./AuthIcons";

type IdentityRowProps = {
  value: string;
  onEdit: () => void;
  editLabel?: string;
};

export function IdentityRow({
  value,
  onEdit,
  editLabel = "Use a different email",
}: IdentityRowProps) {
  return (
    <div className="mio-auth-identity">
      <span className="mio-auth-identity-value">{value}</span>
      <button
        type="button"
        className="mio-auth-identity-edit"
        aria-label={editLabel}
        onClick={onEdit}
      >
        <IconPencil />
      </button>
    </div>
  );
}
